import * as React from "react";
import autobind from "autobind-decorator";
import {Store} from "./store";
import {observer} from "mobx-react";
import {DropWrapper, DropSection} from "./components";
import {Button} from "../../button/index";
import {DateRangePicker} from "../../form/date.range/index";

interface Props<T> {
  store: Store<T>;
  exportUrl: string;
  region: RestaurantSchema["settings"]["region"];
}

interface State {
  start: number;
  end: number;
}

@observer
export class ProtableExport<T> extends React.Component<Props<T>, State> {

  constructor(props: Props<T>) {
    super(props);
    this.state = {
      start: this.daysAgoMills(7),
      end: Date.now(),
    };
  }

  daysAgoMills = (days: number) => {
    return Date.now() - (1000 * 60 * 60 * 24 * days);
  }

  setRange = (start: number) => {
    this.setState({ start, end: Date.now() });
  }

  export = () => {
    const { exportUrl } = this.props;
    const { start, end } = this.state;
    window.open(`${exportUrl}&start=${start}&end=${end}`);
  }

  render() {
    if (!this.state) return;
    const { store, region } = this.props;
    const s = store.s;
    return (
      <DropWrapper active={s.dropdown === "export"}>

        <DropSection>
          <h4 className="">CSV Data Export</h4>
          <p className="m-t-2 lhp max700">You can export all your data into CSV format which can be used by Microsoft Excel and other softwares. Exporting may take a long time if you have a large amount of data. It can also place a large load on our servers so please do not abuse this feature.</p>
        </DropSection>

        <DropSection>
          <p className="big font-semi-bold m-b-3">Export Date Range</p>
          <DateRangePicker
            formats={region.formats}
            timezone={region.timezone}
            start={this.state.start}
            end={this.state.end}
            onSelect={(type, timestamp) => {
              if (type === "start")
                this.setState({ start: timestamp });
              else if (type === "end")
                this.setState({ end: timestamp });
            }}
          />
          <div className="m-t-3">
            <Button
              color="primary-inverse"
              size="xxs"
              onClick={() => this.setRange(this.daysAgoMills(7))}
              className="m-r-2">
              Last 7 Days
            </Button>
            <Button
              color="primary-inverse"
              size="xxs"
              onClick={() => this.setRange(this.daysAgoMills(30))}
              className="m-r-2">
              Last 30 Days
            </Button>
            <Button
              color="primary-inverse"
              size="xxs"
              onClick={() => this.setRange(this.daysAgoMills(1000))}>
              All Time
            </Button>
          </div>
        </DropSection>

        <DropSection>
          <Button color="primary-inverse" size="xs" onClick={this.export}>Export Data</Button>
        </DropSection>

      </DropWrapper>
    );
  }

}
